export class StaffModel
{
    number: number;
    color: string;
    acronym: string;
    displayName: string;
    state: string;
}